import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class MetasConfigService {
  private apiUrl = environment.apiUrl;
  metaUrl = `${this.apiUrl}sistema/empresas/metas/`;

  constructor(private _http: HttpClient) {
  }

  InsertEmpresaMetas(metas): Observable<{}> {
    return this._http.post(this.metaUrl, metas)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  envioEmpresaMeta(metas): Observable<{}> {
    return this._http.post(`${this.metaUrl}envio`, metas)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getConfigMetaEmpresa(empresaId: string, ano, mes): Observable<{}> {
    return this._http.get(this.metaUrl + 'config/' + empresaId + '/' + ano + '/' + mes)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getTipoMetaEmpresa(empresaId, lojaId, tipo, ano, mes): Observable<{}> {
    return this._http.get(this.metaUrl + empresaId + '/' + lojaId.toString() + '/' + tipo + '/' + ano + '/' + (mes + 1))
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  removeTipoMeta(empresaId, ano, mes,  tipo): Observable<any[]> {
    return this._http.delete(this.metaUrl + 'removeTipo/' + empresaId + '/' + ano + '/' + (mes + 1) + '/' + tipo)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  updateDataInicialMeta(empresaId, ano, mes, dataInicial): Observable<any[]> {
    return this._http.patch(this.metaUrl + 'updateData/' + empresaId + '/' + ano + '/' + (mes + 1), {dataInicial: dataInicial})
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getCota(empresaId, lojaId, ano, mes): Observable<any[]> {
    return this._http.get(this.metaUrl + empresaId + '/cota/' + lojaId + '/' + ano + '/' + (mes + 1))
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getMetasEmpresa(empresaId): Observable<any[]> {
    return this._http.get(this.metaUrl + empresaId)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
